import anime from 'animejs/lib/anime.es';
import classNames from 'classnames';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function Note({ analyticsFeatureUseEvent, onChange, className }) {
  const [value, setValue] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const inputContainerRef = useRef();
  const classes = useStyles({ value, isOpen });
  const { t } = useTranslation();
  const inputRef = useRef();

  useEffect(() => {
    if (value != null) {
      onChange?.call(this, value);
    }
  }, [value]);

  useEffect(() => {
    if (!isOpen) {
      setValue('');
    }
  }, [isOpen]);

  const onChangeValue = async (event) => {
    const lValue = event?.target?.value;
    setValue(lValue);

    // if (value !== lValue) onChange?.call(this, lValue);
  };

  function didToogle() {
    analyticsFeatureUseEvent(`order note ${!isOpen ? 'open' : 'close'}`);
    setIsOpen(!isOpen);
  }

  const title = useMemo(() => {
    let action;

    if (isOpen && _.isEmpty(value)) {
      action = 'close';
    } else if (isOpen) {
      action = 'delete';
    } else {
      action = 'add';
    }

    return t(`order.note.${action}`);
  }, [isOpen, value]);

  useEffect(() => {
    anime({
      targets: inputContainerRef.current,
      // opacity: 0.2,
      // direction: "alternate",
      height: isOpen ? 78 : 0,
      duration: 400,
      easing: 'easeInOutQuad',
      loop: false,
      complete: () => {
        if (isOpen === false) {
          onChangeValue(undefined);

          if (inputRef.current != null) {
            inputRef.current.value = null;
          }
        }
      },
    });
  }, [isOpen]);

  return (
    <div className={classNames(className, classes.container)}>
      <Button
        variant="link"
        onClick={() => didToogle()}
        className={classes.link}
      >
        {title}
      </Button>

      <div ref={inputContainerRef} className={classes.inputContainer}>
        <Form.Control
          ref={inputRef}
          placeholder={t('order.note.placeholder')}
          defaultValue=""
          value={value}
          maxLength={30}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="off"
          onChange={onChangeValue}
        />
      </div>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // textAlign: 'center',
    marginTop: 3,
    // fontSize: layoutDefaults.fontSize,
    // marginBottom: layoutDefaults.smallVerticalMargin,
    // border: "1px solid red",
  },
  link: {
    cursor: 'pointer',
    fontSize: layoutDefaults.fontSize,
    // fontSize: layoutDefaults.bigFontSize,
    // color: ({ value, isOpen }) => (!_.isEmpty(value) && isOpen) ? layoutDefaults.destructiveColor : layoutDefaults.linkColor,
    color: layoutDefaults.linkColor,
    padding: 0,
    paddingRight: layoutDefaults.horizontalMargin * 2,
    touchAction: 'pan-x pan-y',
    textAlign: 'left',
    width: '80%',
    // border: "1px solid green",

    // zIndex: 1,
  },
  inputContainer: {
    // marginTop: layoutDefaults.smallVerticalMargin,
    height: 0,
    overflow: 'hidden',

    // border: "1px solid red",
  },
});

export { Note };
